import { useState, useEffect, useRef, useCallback } from 'react';
import { getImageUrl } from '../services/api';

export default function BeforeAfterSlider({ before, after, beforeAlt = 'Öncesi', afterAlt = 'Sonrası' }) {
  const containerRef = useRef(null);
  const [sliderPos, setSliderPos] = useState(50);
  const isDragging = useRef(false);

  const updatePosition = useCallback((clientX) => {
    const container = containerRef.current;
    if (!container) return;
    const rect = container.getBoundingClientRect();
    let percent = ((clientX - rect.left) / rect.width) * 100;
    percent = Math.max(0, Math.min(100, percent));
    setSliderPos(percent);
  }, []);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
    isDragging.current = true;
  }, []);

  const handleMouseMove = useCallback((e) => {
    if (!isDragging.current) return;
    updatePosition(e.clientX);
  }, [updatePosition]);

  const handleMouseUp = useCallback(() => {
    isDragging.current = false;
  }, []);

  const handleTouchMove = useCallback((e) => {
    if (!isDragging.current) return;
    updatePosition(e.touches[0].clientX);
  }, [updatePosition]);

  useEffect(() => {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleMouseUp);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleMouseUp);
    };
  }, [handleMouseMove, handleMouseUp, handleTouchMove]);

  return (
    <div
      className="before-after-slider"
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onTouchStart={() => { isDragging.current = true; }}
    >
      <img
        src={getImageUrl(after)}
        alt={afterAlt}
        className="before-after-img after"
        draggable={false}
      />
      <img
        src={getImageUrl(before)}
        alt={beforeAlt}
        className="before-after-img before"
        draggable={false}
        style={{ clipPath: `inset(0 ${100 - sliderPos}% 0 0)` }}
      />
      <span className="before-after-label before-label">Öncesi</span>
      <span className="before-after-label after-label">Sonrası</span>
      <div className="before-after-handle" style={{ left: `${sliderPos}%` }}>
        <div className="before-after-handle-line" />
        <div className="before-after-handle-circle">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M6 10L2 10M2 10L5 7M2 10L5 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 10L18 10M18 10L15 7M18 10L15 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="before-after-handle-line" />
      </div>
    </div>
  );
}
